module.exports = __webpack_public_path__ + "static/img/three.e5e0bd88.png";